const B2B_TAG_UID = "6b627dd3-4991-41b5-81a3-8979d13d15b9";

const inject = (tagUid) => {
  (function() {
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://tags.inzynk.io/" + tagUid + "/iztag.js";
    (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(s);
  })();
};

export { B2B_TAG_UID, inject };
//# sourceMappingURL=b2x-inzynk.esm.js.map
